import { Carousel } from '@mantine/carousel';
import { createStyles } from '@mantine/core';
import Autoplay from 'embla-carousel-autoplay';
import React, { useEffect, useRef, useState } from 'react';
import { twMerge } from 'tailwind-merge';

// import LeftArrow from 'components/elements/Icon/LeftArrow';
// import RightArrow from 'components/elements/Icon/RightArrow';
import ArrowRight from 'components/DynamicIcon/ArrowRight';

const useStyles = createStyles((_theme, _params, getRef) => {
  return {
    controls: {
      ref: getRef('controls'),
      transition: 'opacity 150ms ease',
      opacity: 0,
    },

    root: {
      '&:hover': {
        [`& .${getRef('controls')}`]: {
          opacity: 1,
        },
      },
      paddingBottom: `${_params.spaceHeightDot}px`,
    },
  };
});

const Slider = (props) => {
  const { content, settings, styleDot = '', spaceHeightDot = 20, reInit = false } = props;
  const setting2 = { ...settings };
  delete setting2.withIndicators;

  const autoplay = useRef(Autoplay({ delay: 5000 }));
  const { classes } = useStyles({ spaceHeightDot });
  const [embla, setEmbla] = useState();
  const [indicatorLength, setIndicatorLength] = useState(1);
  const [selected, setSelected] = useState(0);

  const reInitEmbla = () => {
    if (embla) {
      const slideNodes = embla.slideNodes().length;
      const slidesInView = embla.slidesInView().length > 0 ? embla.slidesInView().length : 1;
      embla.reInit({ slidesToScroll: slidesInView });
      setIndicatorLength(Math.ceil(slideNodes / slidesInView));
    }
  };

  useEffect(() => {
    if (embla || reInit) {
      reInitEmbla();
    }
  }, [props, embla]);

  useEffect(() => {
    if (embla) {
      embla.scrollTo(selected);
    }
  }, [selected]);

  useEffect(() => {
    embla &&
      embla.on('resize', (e) => {
        reInitEmbla();
      });
    embla &&
      embla.on('select', (e) => {
        setSelected(embla.selectedScrollSnap());
      });
    return () => {
      embla && embla.off('resize', () => {});
      embla && embla.off('select', () => {});
    };
  }, [embla]);

  if (content)
    return (
      <>
        <Carousel
          getEmblaApi={(embla) => {
            setEmbla(embla);
          }}
          inViewThreshold={1}
          classNames={{
            control: 'w-10 h-10 bg-ct-neutral-01 border-none shadow-02 opacity-100',
            ...classes,
          }}
          nextControlIcon={
            // <RightArrow className='p-2 bg-ct-neutral-01 text-ct-neutral-03 rounded-full shadow-02' />
            <ArrowRight />
          }
          previousControlIcon={
            // <LeftArrow className='p-2 bg-ct-neutral-01 text-ct-neutral-03 rounded-full shadow-02' />
            <ArrowRight />
          }
          styles={{
            indicator: {
              '&[dataActive]': {
                backgroundColor: '#1D96EE',
              },
            },
            control: {
              '&[data-inactive]': {
                opacity: 0,
                cursor: 'default',
              },
            },
          }}
          plugins={[autoplay.current]}
          onMouseEnter={autoplay.current.stop}
          onMouseLeave={autoplay.current.reset}
          mx='auto'
          withIndicators={false}
          {...setting2}
        >
          {content.map((item, index) => (
            <Carousel.Slide key={index}>
              <div className=''>{item.content}</div>
            </Carousel.Slide>
          ))}
        </Carousel>
        <div className='flex mx-auto w-fit'>
          {settings.withIndicators &&
            Array.from({ length: indicatorLength }, (_, index) => (
              <div className='px-1' key={index} onClick={() => setSelected(index)}>
                <div
                  className={twMerge(
                    `h-3 w-3 rounded-full ${styleDot} ${
                      selected === index ? 'bg-ct-primary-01' : 'bg-ct-neutral-03'
                    }`
                  )}
                ></div>
              </div>
            ))}
        </div>
      </>
    );
};

export default Slider;
